/// FOURJS_START_COPYRIGHT(D,2015)
/// Property of Four Js*
/// (c) Copyright Four Js 2015, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("ComboBoxSimpleConstructWidget", ["ComboBoxWidget"], function (context, cls) {
  /**
   * Combobox widget that allows only a single value in construct Mode
   * @class ComboBoxSimpleConstructWidget
   * @memberOf classes
   * @extends classes.ComboBoxWidget
   * @publicdoc Widgets
   */

  cls.ComboBoxSimpleConstructWidget = context.oo.Class(cls.ComboBoxWidget, function ($super) {
    return /** @lends classes.ComboBoxSimpleConstructWidget.prototype */ {
      __name: "ComboBoxSimpleConstruct",
      __templateName: "ComboBoxWidget",

      /**
       * @inheritDoc
       */
      setWidgetMode: function (mode, _active) {
        if (mode === "Construct") {
          this._allowMultipleValues = false;
          this.getDropDown().allowMultipleChoices(false);
          this._updateInputState();
        }
      },

      /**
       * @inheritDoc
       */
      setQueryEditable: function (_isQueryEditable) {
        // This widget does not support queryEditable in CONSTRUCT
      },

      /**
       * Replicate GDC native CONSTRUCT behavior: a single empty item (no text, no value) that clears
       * the field on selection, instead of the &lt;blank&gt;(=) / &lt;not blank&gt;(!=) items.
       * @inheritDoc
       */
      useSimpleConstructNullItem: function () {
        return true;
      }
    };
  });
  cls.WidgetFactory.registerBuilder("ComboBox[customWidget=comboBoxSimpleConstruct]", cls.ComboBoxSimpleConstructWidget);
});
